import React, { useContext, useState } from 'react';
import { LangContext } from '../../../App'
import String from '../../../Assets/Localization/Local'
import '../Auth.css'
import logo from '../../../Assets/Images/logo.png'
import { Inputs, Validation, config,ImageInput } from './config.js'
import Field from '../../../Components/Fields/Fields'
import { Row, Col, Modal, Container } from 'react-bootstrap'
import axios from 'axios'

const Signup = (props) => {

  const { lang } = useContext(LangContext)
  String.setLanguage(lang);
  const [show, setShow] = useState(true);

  const btnLoginStyle = {
    width: '100%',
    padding: '13px',
    borderRadius: '36px',
    margin: '0 auto',
    outline: 'none',
    border: 'none',
    backgroundImage: 'radial-gradient(#F1AA57, #F6921E)',
    fontSize: "25px"
  }
  const dimButton={
    width: '100%',
    padding: '5px',
    borderRadius: '36px',
    margin: '0 auto',
    outline: 'none',
    border: 'none',
    fontSize: "25px",
    backgroundColor: '#d7d7d7',
  }

  const FieldsContainerStyle={
    paddingTop:'40%'
  }

  return (
    <div className="RegisterStyle">
      <Modal style={{ direction: lang === "ar" ? "rtl" : "" }} show={show} onHide={props.close} animation={false} className="AuthModal text-center">
        <Modal.Body className="p-0">
          <Container fluid>
            <Row className="d-flex justify-content-between authbody">
              <Col lg="6" md="5" className="authlogo px-0" style={{ transform: lang === "ar" ? "" : "rotate(180deg)" }}>
                <img src={logo} alt="logo" style={{ transform: lang === "ar" ? "translate(-45%, -50%)" : "translate(-45%, -50%) rotate(180deg)" }} />
              </Col>
              <Col lg="6" md="7" className="px-0 fixcloseresponsive" style={{ paddingBottom: "40px", paddingTop: "50px" }}>
                <Field inputs={Inputs} ImageUpload={ImageInput}  validation={Validation} config={config} SubmitBtnStyle={btnLoginStyle} FieldsContainerStyle={FieldsContainerStyle} dimButton={dimButton}/>
                <i style={{ left: lang === "ar" ? "10px" : "", right: lang === "en" ? "20px" : "" }} onClick={props.close} className="fa fa-close closeBTN"></i>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Signup;
